"use strict";

window.Components.Basic.Avatar = createReactClass({
  statics: {
    SIZE: {
      smallest: "Avatar--xxs",
      smaller: "Avatar--xs",
      small: "Avatar--sm",
      medium: "Avatar--md",
      large: "Avatar--lg",
      larger: "Avatar--xl"
    }
  },
  propTypes() {
    return {
      profile: PropTypes.object.isRequired,
      size: PropTypes.string
    };
  },
  getDefaultProps() {
    return {
      size: "Avatar--md"
    };
  },
  render() {
    const classes = "Avatar " + this.props.size;
    return /* @__PURE__ */React.createElement("img", {
      src: this.props.profile.photo,
      className: classes
    });
  }
});